import AdminTableFiltersCard from "../ui/AdminTableFiltersCard";

type AdminReviewsFiltersProps = {
  search: string;
  reviewContext: string;
  createdFromDate: string;
  createdToDate: string;
  pageSize: number;
  onSearchChange: (value: string) => void;
  onReviewContextChange: (value: string) => void;
  onCreatedFromDateChange: (value: string) => void;
  onCreatedToDateChange: (value: string) => void;
  onPageSizeChange: (value: number) => void;
};

const AdminReviewsFilters = ({
  search,
  reviewContext,
  createdFromDate,
  createdToDate,
  pageSize,
  onSearchChange,
  onReviewContextChange,
  onCreatedFromDateChange,
  onCreatedToDateChange,
  onPageSizeChange,
}: AdminReviewsFiltersProps) => {
  return (
    <AdminTableFiltersCard>
      <div className="flex flex-wrap items-end gap-3">
        <div className="min-w-[320px] flex-[2_1_360px]">
          <label htmlFor="admin-reviews-filter-search" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Search
          </label>
          <input
            id="admin-reviews-filter-search"
            type="text"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Gig, reviewer, reviewee, teen, poster, message"
            className="w-full rounded-lg border border-myteengig-border bg-white px-4 py-3 text-base text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>
        <div className="min-w-[190px] flex-[1_1_210px]">
          <label htmlFor="admin-reviews-filter-context" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Context
          </label>
          <select
            id="admin-reviews-filter-context"
            value={reviewContext}
            onChange={(event) => onReviewContextChange(event.target.value)}
            className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          >
            <option value="">All contexts</option>
            <option value="WORKER_PERFORMANCE">Worker performance</option>
            <option value="POSTER_EXPERIENCE">Poster experience</option>
          </select>
        </div>
        <div className="min-w-[150px] flex-[0_1_170px]">
          <label htmlFor="admin-reviews-filter-created-from" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Created From
          </label>
          <input
            id="admin-reviews-filter-created-from"
            type="date"
            value={createdFromDate}
            onChange={(event) => onCreatedFromDateChange(event.target.value)}
            className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>
        <div className="min-w-[150px] flex-[0_1_170px]">
          <label htmlFor="admin-reviews-filter-created-to" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Created To
          </label>
          <input
            id="admin-reviews-filter-created-to"
            type="date"
            min={createdFromDate || undefined}
            value={createdToDate}
            onChange={(event) => onCreatedToDateChange(event.target.value)}
            className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>
        <div className="min-w-[110px] flex-[0_1_120px]">
          <label htmlFor="admin-reviews-filter-page-size" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Rows
          </label>
          <select
            id="admin-reviews-filter-page-size"
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
            className="h-[50px] w-full rounded-lg border border-myteengig-border bg-white px-4 text-sm font-medium text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </select>
        </div>
      </div>
    </AdminTableFiltersCard>
  );
};

export default AdminReviewsFilters;
